module.exports = __webpack_public_path__ + "static/cable-72c90f3f55d4123c6c724d3c87a75978.png";